import { render, staticRenderFns } from "./ShowCollaboration.vue?vue&type=template&id=7729a3ac&"
import script from "./ShowCollaboration.vue?vue&type=script&lang=js&"
export * from "./ShowCollaboration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports